/**
 * Function to replace dash with dot to be equal to the pdf
 * @param {string} key
 * @returns {string}
 */
export const replaceCompetenceKeyDashesWithDots = (key: string | undefined): string => {
	if (!key) {return ''}
	if(key.length === 1) {
		return key
	}

	return key.substring(0,3).replace('-', '.')
}